import app from 'flarum/forum/app';
import { override, extend } from 'flarum/common/extend';
import { userHasAccess } from '../../util';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import NotAuthModal from '../components/NotAuthModal';
import PostUser from 'flarum/forum/components/PostUser';
import SubtreeRetainer from 'flarum/common/utils/SubtreeRetainer';
import TerminalPost from 'flarum/forum/components/TerminalPost';
import dayjs from 'dayjs';


export default () => {
    extend(DiscussionPage.prototype, 'sidebarItems', function(items) {
        if (items.has('lastDiscussionViewers')) items.remove('lastDiscussionViewers');
        if (items.has('share-social')) items.remove('share-social');
        if (items.has('controls')) items.remove('controls');
        if (items.has('subscription')) items.remove('subscription');

        return items;
    });

    // This watches for new posts being added to the stream, and if so, the
    // whole stream is redrawn to allow re-indexing the posts by mentions
    let initialStreamCount = 0;
    override(DiscussionPage.prototype, 'onupdate', function(original) {
        original();
        const stream = app.current.get('stream');

        if (stream && initialStreamCount === 0) {
          initialStreamCount = stream.count();
        }


        if (stream && stream.count() > initialStreamCount) {
          initialStreamCount = stream.count();
          setTimeout(() => {this.load(); m.redraw()}, 300);
        }
    });

    extend(DiscussionPage.prototype, 'view', function() {
        const message = $('.AlertManager .Alert--error .Alert-body').text().trim();

        if (!app.session.user && message && message.includes('Please reload the page and try again')) {
            setTimeout(() => m.route.set(`/become-a-member?redirect=${m.route.get()}`), 300)
            $('.AlertManager .Alert--error').hide();
        }
    });

    const ogDiscussionListOninit = DiscussionListItem.prototype.oninit;
    DiscussionListItem.prototype.oninit = function(vnode) {

        if (ogDiscussionListOninit) {
            ogDiscussionListOninit.call(this, vnode);
        }

        this.cardVisible = false;
        this.subtree = new SubtreeRetainer(
            () => this.attrs.discussion.freshness,
            () => {
              const time = app.session.user && app.session.user.markedAllAsReadAt();
              return time && time.getTime();
            },
            () => this.active(),
            () => this.cardVisible,
            () => vnode.state.loading
          );

        vnode.state.loading = true;
    }

    extend(DiscussionListItem.prototype, ['oncreate', 'onupdate'], function() {
        // if the discussion has no tags, remove stray terminalPost
        const items = this.$('.DiscussionListItem-info .item-terminalPost:first-child');
        items?.length && items[0].remove()
    });

    // Default flarum sorts have a "Show Unread" sort. When this is selected, the "Replies" count actually changes to
    // show "Unread" counts. But we don't support this. So let's just force it to always return the number of replies.
    override(DiscussionListItem.prototype, 'showRepliesCount', () => true);

    override(DiscussionListItem.prototype, 'view', function () {
        const discussion = this.attrs.discussion;

        const controls = DiscussionControls.controls(discussion, this).toArray();
        const attrs = this.elementAttrs();

        const controlView = this.controlsView(controls);
        const slidableUnderneathView = this.slidableUnderneathView();
        const contentView = this.contentView();

        // If on post detail page, and the discussions are in the slide over tab
        const discussionListItemWidth = document.querySelector('.DiscussionListItem')?.getBoundingClientRect().width;
        const isDiscussionSlideOver = app.session.user && window.innerWidth >= 768 && discussionListItemWidth < 432;

        contentView.children = contentView.children.concat(slidableUnderneathView).concat(controlView);
        contentView.attrs.className = `DiscussionListItem-content
            ${discussion.isRead() || !!discussion.lastReadAt() ? 'is-read' : 'not-read'}
            ${isDiscussionSlideOver ? 'DiscussionListItem-content-slideOver' : ''}`;

        // If logged in mark as read when the main post link is clicked
        const discussionMain = contentView.children[2];
        discussionMain.attrs.onclick = (e) => {
            if (!userHasAccess()) {
                e.preventDefault();
                app.modal.show(NotAuthModal);
                return;
            }

            if (!app.session.user) {
                e.preventDefault();
                setTimeout(() => m.route.set(`/become-a-member?redirect=${m.route.get()}`), 300)
                return;
            }

            // if access, mark as read
            setTimeout(() => this.markAsRead(), 300);
        };

        // Remove slideable content
        contentView.children.splice(4, 1);

        // Get discussion views and replies count for formatting
        const repliesCount = this.replyCountItem();
        repliesCount.tag = 'p';
        // if(!discussion.isRead()) {
        //     // if the discussion is unread, this will be the unread count which we do not use
        //     repliesCount.children[0].text = '0'
        // }
        const controlDropdown = contentView.children[4];

        const views  = discussion.data.attributes?.viewCount;

        // Remove original views count
        contentView.children[2].children[1].children.pop();

        contentView.children[3] =
            <div style={`${window.innerWidth > 768 ? (app.session.user ? 'margin-top: -20px;' : 'margin-top: -40px;') : ''}`}
                 className='DiscussionListItem-controlContainer'
                >
                {controlDropdown}
                <div style={`${app.session.user ? 'margin-top: -32px;' : ''}`} className='DiscussionListItem-replies'>
                    {repliesCount}
                    <p class="DiscussionListItem-views">{views}</p>
                </div>
            </div>;

        // Replace original avatar with postUser
        const postUserContent =
                <div className='DiscussionListItem-postUser'>
                    <div className='DiscussionListItem-author'>
                        <PostUser
                            post={discussion}
                            cardVisible={true}
                            oncardshow={() => {
                                this.cardVisible = true
                                m.redraw()
                            }}
                            oncardhide={() => {
                                this.cardVisible = false
                                m.redraw()
                            }}
                            isDiscussionPage={true}
                        />

                        <br />
                        <p className='created-at'>
                            started {`${discussion?.createdAt() ? dayjs(discussion.createdAt()).format('MMM DD, YYYY') : 'unknown'}`}
                        </p>

                        <span className='item-terminalPost'><TerminalPost discussion={discussion} lastPost={!this.showFirstPost()} /></span>
                    </div>
                    <br />
                </div>

        // Place postUserContent back into the DiscussionListItem-info container
        const discussionInfoContainer = contentView.children[2].children[1];
        discussionInfoContainer.children.splice(1, 0, postUserContent);

        // Remove dupe if it exists
        const terminalPostIndex = discussionInfoContainer.children.findIndex(item => item.key === 'terminalPost');
        if (terminalPostIndex === 2 ) {
            discussionInfoContainer.children.splice(terminalPostIndex, 1);
        }

        // Remove the old control dropdown
        contentView.children.splice(4, 1);

        // Category tag labels
        const tagsContainer = contentView.children[2].children[1].children[0]?.children[0];

        // if mobile, limit tags in container to 1
        if (tagsContainer && tagsContainer?.tag === 'span' && window.innerWidth < 768) {
            tagsContainer.children = tagsContainer.children?.slice(0, 1);
        }

        // if desktop, limit tags in container to 3
        if (tagsContainer && window.innerWidth > 768) {
            tagsContainer.children = tagsContainer.children?.slice(0, 3);
        }

        // if there is more than one category, break each tag into its own container
        if (tagsContainer.children?.length > 1 && tagsContainer?.tag === 'span') {
            tagsContainer.children = tagsContainer.children.map(tag => {
                return <div className='TagLabel-div'>{tag}</div>
            });
        }

        // Remove OG authorAvatar and authorBadges
        const ogAutorAvatar  = contentView.children[0]?.children?.find(child => child.attrs?.className === 'DiscussionListItem-author');
        if (ogAutorAvatar) {
            contentView.children[0].children[0].children.splice(0, 1);
            contentView.children.splice(1, 1);
        }

        return (
          <div {...attrs}>
            {contentView}
          </div>
        );
    });
}
